import { useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import { useLayoutEffectWithoutSSRComplaining } from '@wix/da-hooks/pkg/useLayoutEffectWithoutSSRComplaining';
var THROTTLE_MS = 200;
export function useScrollRestore(isPageOpen) {
    var _a = useState(typeof window !== 'undefined' ? window.scrollY : 0), scrollPos = _a[0], setScrollPos = _a[1];
    // Track wasOpen so we can avoid scrolling on pageload
    var wasOpen = useRef(false);
    useEffect(function () {
        if (isPageOpen) {
            wasOpen.current = true;
        }
    }, [isPageOpen]);
    // Track the window scroll and store it locally
    useEffect(function () {
        if (window) {
            var handleScroll_1 = throttle(function () {
                requestAnimationFrame(function () {
                    if (!isPageOpen) {
                        setScrollPos(window.scrollY);
                    }
                });
            }, THROTTLE_MS);
            window.addEventListener('scroll', handleScroll_1);
            return function () { return window.removeEventListener('scroll', handleScroll_1); };
        }
    }, [scrollPos, isPageOpen]);
    // After rendering scroll to the last known position
    useLayoutEffectWithoutSSRComplaining(function () {
        if (wasOpen.current && !isPageOpen && scrollPos) {
            window.scrollTo({ top: scrollPos });
        }
    }, [isPageOpen]);
}
//# sourceMappingURL=useScrollRestore.js.map